const CommonApi = {
    getAppStart: '/common/start'
}

export default CommonApi
